<template>
    <multiselect
        v-model="selected_value"
        :options="options"
        :searchable="true"
        :placeholder="'Search children by name'"
        selectLabel="search"
        deselectLabel=""
        selectedLabel=""
        :disabled="disabled"
        :multiple="multiple"
        :loading="loading"
        :label="label"
        trackBy="id"
        @search-change="getData"
        style="min-width: 200px"
    >
        <template slot="noResult"> Not found</template>
        <template slot="noOptions"> Search children by name</template>
        <template slot="caret">
            <inline-svg class="multiselect-icon" src="/assets/img/icons/search-icon.svg"></inline-svg>
        </template>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import debounce from 'lodash/debounce';

export default {
    name: 'UserFromGroupSelect',
    props: ['value', 'disabled', 'multiple', 'type', 'placeholder', 'label'],
    components: {Multiselect},
    data() {
        return {
            selected_value: null,
            loading: false,
            options: [],
        };
    },
    methods: {
        getData: debounce(function (query) {
            if (!query) {
                return;
            }
            this.loading = true;
            this.$http.post('/user/search', {
                query,
                user_type: this.type,
            })
                .then(function (res) {
                    this.loading = false;
                    this.options = res.body.users;
                }).catch(() => {
                this.loading = false;
            });
        }, 500),
    },
    watch: {
        value(a) {
            this.selected_value = a;
        },
        selected_value(option) {
            if (!option) {
                this.$emit('input', null);
                this.$emit('change', null);
                this.$emit('setId', null);
            } else {
                this.$emit('input', option);
                this.$emit('change', option);
                this.$emit('setId', option ? option.id : null);
            }
        },
    },
    mounted() {
        if (this.value) {
            this.selected_value = this.value;
        }
    },
};
</script>
